import NavMenu from "./NavMenu.js";

export default (el, i) => {
  const onClose = () => {};
  const onOpen = () => {};

  const menu = NavMenu({
    animationDelay: 800,
    closed: true,
    direction: "",
    menuButton: ".js-search-button",
    menuContainer: ".js-search-content",
    navigationLink: "input, button",
    openClass: "is-open",
    onClose: onClose,
    onOpen: onOpen,
    parent: el,
  });

  let initialized = true;

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      if(window.innerWidth >= 1240 && initialized) {
        menu.kill();
        initialized = false;
      }
      if(window.innerWidth < 1240 && !initialized) {
        menu.init();
        initialized = true;
      }
    }
  });

  resizeObserver.observe(document.querySelector("body"));
};
